import userReducer from "../../store/slices/userSlice";
import authReducer from "../../store/slices/authSlice";
import viewReducer from "../../designer/store/slices/viewSlice";
import productReducer from "../../designer/store/slices/productSlice";
import stepSlice from "../../designer/store/slices/stepSlice";
import sidebarSlice from "../../designer/store/slices/sidebarSlice";

//import garmentColorReducer from "store/slices/garmentColorSlice";
export default {
  user: userReducer,
  auth: authReducer,
  canvases: viewReducer,
  product: productReducer,
  steps: stepSlice,
  sidebar: sidebarSlice,

  //agreement: agreementReducer,

  //garmentColor: garmentColorReducer,
};
